<template>
  <div class="faq-warpper">
    <my-brand :routerlist="routerlist" />
    <h2>What is the art club?</h2>
    <p>This is a club for connoisseurs of generative art founded by ********</p>
    <h2>What does membership in the club provide?</h2>
    <p>Membership guarantees each member a free mint of all Playground releases on artblocks.io from Shvembldr for 24 hours before the official release. As well as other bonuses and perks, such as participation in events</p>
    <h2>If I got a token am I a member of the club?</h2>
    <p>No, the token entitles you to one free art in one release only. Membership can only be obtained in the ways described below</p>
    <h2>How can I get into the club</h2>
    <p>There are several ways:</p>
    <p>Collect 9 The Blocks of Art with *******. OpenSea</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    routerlist(){
      return [{to:'/',name:'Home'},{to:'/members',name:'Members'},{name:'Faq'}];
    }
  },
};
</script>

<style lang="less" scoped>
.faq-warpper {
  padding: 0 20px 40px;
  h2{
      font-size: 30px;
      text-align: center;
      margin-top: 20px;
      font-weight: 600;
  }
  p{
      font-size: 18px;
      text-align: center;
      margin: 20px 0;
  }
}
</style>